import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PlayerButton from '../PlayerButton';
import Video from 'components/svg/Video';
import JWPlayer from './JWPlayer';
import { playbackModes } from 'store/reducers/player';
import { isEmpty } from 'util/index';
import { createUseStyles } from 'react-jss';

import styles from './PlayerVideo.styles';

const useStyles = createUseStyles(styles, { name: 'PlayerVideo' });

const PlayerVideo = ({
  playbackMode,
  isPlaying,
  onSetPlaybackToLiveAudio,
  onSetPlaybackToLiveVideo,
  currentStation,
}) => {
  const classes = useStyles();

  let videoCloseAction = null;
  const [visible, setVisible] = useState(true);
  const isLiveVideo = playbackMode === playbackModes.LIVE_VIDEO;
  const isLiveAudio = playbackMode === playbackModes.LIVE_AUDIO;

  useEffect(() => {
    // If HD Audio is press check if it was playing video and hide it
    if (isLiveAudio && visible && videoCloseAction) {
      setVisible(false);
      videoCloseAction();
    }
  }, [playbackMode]);

  if (isEmpty(currentStation) || !currentStation.videoUrl) return null;

  const onPress = (isOpening) => {
    setVisible(isOpening);
    setTimeout(() => {
      if (isOpening) {
        if (!isLiveVideo || !isPlaying) {
          onSetPlaybackToLiveVideo(currentStation);
        }
        return;
      }

      if (!isLiveAudio || !isPlaying) {
        onSetPlaybackToLiveAudio(currentStation);
      }
    }, 100);
  };

  /**
   * Renders JSX for a video player (JWPlayer)
   * @returns {object} JSX
   */
  const renderPopout = (closeBtn, closeAction) => {
    videoCloseAction = closeAction;
    return (
      <div className={classes.videoWrapper}>
        {closeBtn}
        <JWPlayer isShown={visible} />
      </div>
    );
  };

  const renderIcon = () => {
    return <Video />;
  };

  return (
    <PlayerButton
      data-testid="player-bottom-player-video-btn"
      onPress={onPress}
      title="Video"
      renderIcon={renderIcon}
      renderPopout={renderPopout}
      hasPopout
      hideOnSmall
    />
  );
};

PlayerVideo.defaultProps = {
  currentStation: null,
  isPlaying: false,
};

PlayerVideo.propTypes = {
  playbackMode: PropTypes.string.isRequired,
  isPlaying: PropTypes.bool,
  onSetPlaybackToLiveAudio: PropTypes.func.isRequired,
  onSetPlaybackToLiveVideo: PropTypes.func.isRequired,
  currentStation: PropTypes.object,
};

export default PlayerVideo;
